module.exports = __webpack_public_path__ + "img/icn_maisopcoes.4ff19e43.svg";